import React from "react";

const Dot = ({ color }: any) => {
  const dotStyle = {
    width: "10px",
    height: "10px",
    borderRadius: "50%",
    backgroundColor: color,
    display: "inline-block",
  };

  return <div style={dotStyle}></div>;
};

export default Dot;
